@if (value) {
  <love-it-generic-icon
    selector="check"
    class="text-info"></love-it-generic-icon>
}
@if (!value) {
  <love-it-generic-icon
    selector="x"
    class="text-danger"></love-it-generic-icon>
}
